module.exports = __webpack_public_path__ + "static/media/savedArrows.23b0c3ef.svg";